/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Change_Auto_RerateInputs */

const en_orders_change_auto_rerate = /** @type {(inputs: Orders_Change_Auto_RerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change + Auto-Rerate`)
};

const es_orders_change_auto_rerate = /** @type {(inputs: Orders_Change_Auto_RerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar + Auto-rerate`)
};

/**
* | output |
* | --- |
* | "Change + Auto-Rerate" |
*
* @param {Orders_Change_Auto_RerateInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_change_auto_rerate = /** @type {((inputs?: Orders_Change_Auto_RerateInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Change_Auto_RerateInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_change_auto_rerate(inputs)
	return es_orders_change_auto_rerate(inputs)
});